const firebaseConfig = {
    apiKey: "AIzaSyCXG1d2FaZSpQbZ2uFnL0NK9J6vpI2lBI8",
    authDomain: "qazaa-namaaz-tracker-98616.firebaseapp.com",
    projectId: "qazaa-namaaz-tracker-98616",
    storageBucket: "qazaa-namaaz-tracker-98616.firebasestorage.app",
    messagingSenderId: "283841012181",
    appId: "1:283841012181:web:7c95e1eae7de1458cedd5c",
    measurementId: "G-KEM2SZDKJ3"
  };

export {firebaseConfig}